module.exports = __webpack_public_path__ + "img/non-monetary_1x.07d00ca.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/raf/non-monetary_1x.png
// module id = 690
// module chunks = 0